// Per-account keys for device-local state that shared code (utils/*) stores through AsyncStorage.
//
// utils/chatReadTracker keys chat read markers as `chat_last_read_<chatId>` with no account in
// them. On mobile that is one account per device install; on the web several accounts share one
// browser, so the web AsyncStorage shim (shims/asyncStorage.js) rewrites those keys to
// `chat_last_read_<uid>:<chatId>` for the signed-in uid. One account's reads then never hide
// another account's unread chats. The mobile key shape is unchanged.
//
// scopeStorageKey(key, uid) -> the key to use, or null when the key is per-account and there is no
// signed-in uid (reads then return nothing and writes are dropped).
const ACCOUNT_SCOPED_PREFIXES = ["chat_last_read_"];

export function scopeStorageKey(key, uid) {
  if (typeof key !== "string") return key;
  const prefix = ACCOUNT_SCOPED_PREFIXES.find((p) => key.startsWith(p));
  if (!prefix) return key;
  if (!uid) return null;
  return `${prefix}${uid}:${key.slice(prefix.length)}`;
}
